<template>
  <svg
    width="12px"
    height="12px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C13.1046 2 14 2.89543 14 4C14 5.10457 13.1046 6 12 6C10.8954 6 10 5.10457 10 4C10 2.89543 10.8954 2 12 2Z"
      fill="currentColor"
    />
    <path
      d="M21 9H20C19.4477 9 19 9.44772 19 10V14C19 14.5523 19.4477 15 20 15H21C21.5523 15 22 14.5523 22 14V10C22 9.44772 21.5523 9 21 9Z"
      fill="currentColor"
    />
    <path
      d="M4 9H3C2.44772 9 2 9.44772 2 10V14C2 14.5523 2.44772 15 3 15H4C4.55228 15 5 14.5523 5 14V10C5 9.44772 4.55228 9 4 9Z"
      fill="currentColor"
    />
    <path
      d="M13 8.5C13 8.22386 12.7761 8 12.5 8H11.5C11.2239 8 11 8.22386 11 8.5V15.5C11 15.7761 11.2239 16 11.5 16H12.5C12.7761 16 13 15.7761 13 15.5V8.5Z"
      fill="currentColor"
    />
    <path
      d="M18 11H14.5C14.2239 11 14 11.2239 14 11.5V12.5C14 12.7761 14.2239 13 14.5 13H18V11Z"
      fill="currentColor"
    />
    <path
      d="M10 11H5V13H9.5C9.77614 13 10 12.7761 10 12.5V11.5C10 11.2239 9.77614 11 9.5 11H10Z"
      fill="currentColor"
    />
    <path
      d="M8 18C8 17.4477 8.44772 17 9 17H15C15.5523 17 16 17.4477 16 18V20C16 21.1046 15.1046 22 14 22H10C8.89543 22 8 21.1046 8 20V18Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "ActivityIcon",
};
</script>